<script>
/**
 * Right sidebar (painel de customizacao de tema).
 * No template base, este componente e um placeholder vazio.
 * Adicione aqui opcoes de layout/tema se necessario.
 */
export default {
  name: "RightBar",
};
</script>

<template>
  <div></div>
</template>
